export function getView(status, provider) {
  return status === 'active' && provider === 'payabli'
}
